module.exports = "\r\n#ex3 .fa-stack[data-count]:after{\r\n  position:absolute;\r\n  right:0%;\r\n  top:1%;\r\n  content: attr(data-count);\r\n  font-size:60%;\r\n  padding:.6em;\r\n  border-radius:50%;\r\n  line-height:.8em;\r\n  color: white;\r\n  background:rgba(255,0,0,.85);\r\n  text-align:center;\r\n  min-width: 1em;\r\n  font-weight:bold;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/brand-logo/brand-logo.component.css
// module id = ./src/app/components/brand-logo/brand-logo.component.css
// module chunks = main